
<div style="width: 100%; text-align: right;">
  <button (click)="sair()" mat-icon-button class="example-icon">
    <img src="../../assets/img/icones/cancel.png" width="40px">
  </button>
  &nbsp;&nbsp;&nbsp;
</div>
<br/> 

<div class="backgroundDialog" style="width: 100%;  height: 100%; padding: 10px;margin: auto; border: 5px solid rgb(207, 121, 1);">
  
  



  <!-- *** MOSTRAR APENAS ESSA DIV *** -->
  <div style="width: 100%; height: 100%; text-align: left; ">
    
    <div class='row' style="margin-top: 10px; font-size: 12px;">
      <div class='col-3'>
        <div *ngIf="statusProcessamentoCompleto==0">
          <div class="loader">
            <div class="wrapper">
              <div class="text">AGUARDANDO</div>
              <div class="box"></div>
            </div>
          </div>
        </div>
        <div *ngIf="statusProcessamentoCompleto==1" class="boxProcessando">
          PROCESSANDO...
        </div>
        <div *ngIf="statusProcessamentoCompleto==2" class="boxAprovado">
          SUCESSO
        </div>
        <div *ngIf="statusProcessamentoCompleto==3" class="boxErro">
          ERRO
        </div>         
      </div>
      <div class='col-9'>  
        <mat-card class="cardLabelProcessado">
          <label>
                   Formulário: {{data.dsFormulario}} COPIA 
              <br/>Gerado com Sucesso [ID: {{novoFormularioCriado}}]
          </label>
        </mat-card>          
      </div>
    </div>

  </div>
  
  
  
  <!-- *** DIV ANTIGA  HIDDEN *** -->
  <div hidden style="width: 100%; height: 100%; text-align: left; ">
    
    
    <div class='row' style="margin-top: 10px;">
      <div class='col-3' style="text-align: center;">
        <div *ngIf="ajustandoTabelas==0">
          <div class="loader">
            <div class="wrapper">
              <div class="text">AGUARDANDO</div>
              <div class="box"></div>
            </div>
          </div>
        </div>
        <div *ngIf="ajustandoTabelas==1" class="boxProcessando">
          PROCESSANDO...
        </div>
        <div *ngIf="ajustandoTabelas==2" class="boxAprovado">
          SUCESSO
        </div>
        <div *ngIf="ajustandoTabelas==3" class="boxErro">
          ERRO
        </div>
      </div> 
      <div class='col-9'>  
          <mat-card [class]="ajustandoTabelas==1 ? 'cardLabelProcessando' : 
                              ajustandoTabelas==2 ? 'cardLabelProcessado' :
                              ajustandoTabelas==3 ? 'cardLabelErro' :
                              'cardLabel' ">
                              <label *ngIf="ajustandoTabelas==1 || ajustandoTabelas==0">Ajuste de tabelas</label>
                              <label *ngIf="ajustandoTabelas==2">Ajuste de tabelas</label>
                              <label *ngIf="ajustandoTabelas==3">Ao ajustar tabelas</label>
          </mat-card>
         
      </div>
      
    </div>



    
    <div class='row' style="margin-top: 10px;">
      <div class='col-3'>
        <div *ngIf="criandoFormulario==0">
          <div class="loader">
            <div class="wrapper">
              <div class="text">AGUARDANDO</div>
              <div class="box"></div>
            </div>
          </div>
        </div>
        <div *ngIf="criandoFormulario==1" class="boxProcessando">
          PROCESSANDO...
        </div>
        <div *ngIf="criandoFormulario==2" class="boxAprovado">
          SUCESSO
        </div>
        <div *ngIf="criandoFormulario==3" class="boxErro">
          ERRO
        </div>         
      </div>
      <div class='col-9'>  
        <mat-card [class]="criandoFormulario==1 ? 'cardLabelProcessando' : 
                           criandoFormulario==2 ? 'cardLabelProcessado' :
                           criandoFormulario==3 ? 'cardLabelErro' :
                          'cardLabel' ">
            
                          <label *ngIf="criandoFormulario==1 || criandoFormulario==0">Criação do Formulário </label>
                          <label *ngIf="criandoFormulario==2">Na criação do Formulario </label>
                          <label *ngIf="criandoFormulario==3">Ao criar Formulário </label>
              
          </mat-card>          
      </div>
      
    </div>



    <div class='row' style="margin-top: 10px;">
      <div class='col-3'>       
        <div *ngIf="criandoMotivos==0">
          <div class="loader">
            <div class="wrapper">
              <div class="text">AGUARDANDO</div>
              <div class="box"></div>
            </div>
          </div>
        </div>
        <div *ngIf="criandoMotivos==1" class="boxProcessando">
          PROCESSANDO...
        </div>
        <div *ngIf="criandoMotivos==2" class="boxAprovado">
          SUCESSO
        </div>
        <div *ngIf="criandoMotivos==3" class="boxErro">
          ERRO
        </div>   
      </div> 
      <div class='col-9'> 
        <mat-card [class]="criandoMotivos==1 ? 'cardLabelProcessando' : 
                        criandoMotivos==2 ? 'cardLabelProcessado' :
                        criandoMotivos==3 ? 'cardLabelErro' :
                        'cardLabel' ">
            
                          <label *ngIf="criandoMotivos==1 || criandoMotivos==0">Criação de Motivos (do cabeçalho) </label>
                          <label *ngIf="criandoMotivos==2">Na criação de Motivos (do cabeçalho) </label>
                          <label *ngIf="criandoMotivos==3">Ao criar Motivos (do cabeçalho) </label>
          </mat-card>          
      </div>
      
      
    </div>



    <div class='row' style="margin-top: 10px;">
      <div class='col-3'>
        <div *ngIf="criandoParametros==0">
          <div class="loader">
            <div class="wrapper">
              <div class="text">AGUARDANDO</div>
              <div class="box"></div>
            </div>
          </div>
        </div>
        <div *ngIf="criandoParametros==1" class="boxProcessando">
          PROCESSANDO...
        </div>
        <div *ngIf="criandoParametros==2" class="boxAprovado">
          SUCESSO
        </div>
        <div *ngIf="criandoParametros==3" class="boxErro">
          ERRO
        </div>       
      </div> 
      <div class='col-9'>  
        <mat-card [class]="criandoParametros==1 ? 'cardLabelProcessando' : 
                            criandoParametros==2 ? 'cardLabelProcessado' :
                            criandoParametros==3 ? 'cardLabelErro' :
                            'cardLabel' ">
            
                          <label *ngIf="criandoParametros==1 || criandoParametros==0">Criação de Parametros (Cabeçalho) </label>
                          <label *ngIf="criandoParametros==2">Na criação de Parametros (Cabeçalho) </label>
                          <label *ngIf="criandoParametros==3">Ao criar Parametros (Cabeçalho) </label>
          </mat-card>          
      </div>
      
    </div>



    <div class='row' style="margin-top: 10px;">
      <div class='col-3'>
        <div *ngIf="criandoVinculosDeParametrosMotivos==0">
          <div class="loader">
            <div class="wrapper">
              <div class="text">AGUARDANDO</div>
              <div class="box"></div>
            </div>
          </div>
        </div>
        <div *ngIf="criandoVinculosDeParametrosMotivos==1" class="boxProcessando">
          PROCESSANDO...
        </div>
        <div *ngIf="criandoVinculosDeParametrosMotivos==2" class="boxAprovado">
          SUCESSO
        </div>
        <div *ngIf="criandoVinculosDeParametrosMotivos==3" class="boxErro">
          ERRO
        </div>      
      </div> 
      <div class='col-9'>  
        <mat-card [class]="criandoVinculosDeParametrosMotivos==1 ? 'cardLabelProcessando' : 
                            criandoVinculosDeParametrosMotivos==2 ? 'cardLabelProcessado' :
                            criandoVinculosDeParametrosMotivos==3 ? 'cardLabelErro' :
                          'cardLabel' ">
            
                          <label *ngIf="criandoVinculosDeParametrosMotivos==1 || criandoVinculosDeParametrosMotivos==0">Criação de Vinculos de Motivos em Cabeçalhos </label>
                          <label *ngIf="criandoVinculosDeParametrosMotivos==2">Na criação de Vinculos de Motivos em Cabeçalhos </label>
                          <label *ngIf="criandoVinculosDeParametrosMotivos==3">Ao criar Vinculos de Motivos em Cabeçalhos </label>
          </mat-card>          
      </div>
      
    </div>
   

    
    <div class='row' style="margin-top: 10px;">
      <div class='col-3'>
        <div *ngIf="criandoGruposCategroria==0">
          <div class="loader">
            <div class="wrapper">
              <div class="text">AGUARDANDO</div>
              <div class="box"></div>
            </div>
          </div>
        </div>
        <div *ngIf="criandoGruposCategroria==1" class="boxProcessando">
          PROCESSANDO...
        </div>
        <div *ngIf="criandoGruposCategroria==2" class="boxAprovado">
          SUCESSO
        </div>
        <div *ngIf="criandoGruposCategroria==3" class="boxErro">
          ERRO
        </div>       
      </div> 
      <div class='col-9'>  
        <mat-card [class]="criandoGruposCategroria==1 ? 'cardLabelProcessando' : 
                            criandoGruposCategroria==2 ? 'cardLabelProcessado' :
                            criandoGruposCategroria==3 ? 'cardLabelErro' :
                          'cardLabel' ">
             
                          <label *ngIf="criandoGruposCategroria==1 || criandoGruposCategroria==0">Criação de Grupos de Categorias </label>
                          <label *ngIf="criandoGruposCategroria==2">Na criação de Grupos de Categorias </label>
                          <label *ngIf="criandoGruposCategroria==3">Ao criar Grupos de Categorias </label>
          </mat-card>          
      </div>
      
    </div>


    
    <div class='row' style="margin-top: 10px;">
      <div class='col-3'>
        <div *ngIf="criandoCategorias==0">
          <div class="loader">
            <div class="wrapper">
              <div class="text">AGUARDANDO</div>
              <div class="box"></div>
            </div>
          </div>
        </div>
        <div *ngIf="criandoCategorias==1" class="boxProcessando">
          PROCESSANDO...
        </div>
        <div *ngIf="criandoCategorias==2" class="boxAprovado">
          SUCESSO
        </div>
        <div *ngIf="criandoCategorias==3" class="boxErro">
          ERRO
        </div>     
      </div> 
      <div class='col-9'>  
        <mat-card [class]="criandoCategorias==1 ? 'cardLabelProcessando' : 
                            criandoCategorias==2 ? 'cardLabelProcessado' :
                            criandoCategorias==3 ? 'cardLabelErro' :
                          'cardLabel' ">
             
                        <label *ngIf="criandoCategorias==1 || criandoCategorias==0">Criação de Categorias </label>
                        <label *ngIf="criandoCategorias==2">Na criação de Categorias </label>
                        <label *ngIf="criandoCategorias==3">Ao criar Categorias </label>

          </mat-card>          
      </div>
      
    </div>



    
    <div class='row' style="margin-top: 10px;">
      <div class='col-3'>
        <div *ngIf="criandoPerguntas==0">
          <div class="loader">
            <div class="wrapper">
              <div class="text">AGUARDANDO</div>
              <div class="box"></div>
            </div>
          </div>
        </div>
        <div *ngIf="criandoPerguntas==1" class="boxProcessando">
          PROCESSANDO...
        </div>
        <div *ngIf="criandoPerguntas==2" class="boxAprovado">
          SUCESSO
        </div>
        <div *ngIf="criandoPerguntas==3" class="boxErro">
          ERRO
        </div>         
      </div> 
      <div class='col-9'>  
        <mat-card [class]="criandoPerguntas==1 ? 'cardLabelProcessando' : 
                            criandoPerguntas==2 ? 'cardLabelProcessado' :
                            criandoPerguntas==3 ? 'cardLabelErro' :
                          'cardLabel' ">
           
                        <label *ngIf="criandoPerguntas==1 || criandoPerguntas==0">Criação de Perguntas </label>
                        <label *ngIf="criandoPerguntas==2">Na criação de Perguntas </label>
                        <label *ngIf="criandoPerguntas==3">Ao criar Perguntas </label>
                        
          </mat-card>          
      </div>
      
    </div>


    
    <div class='row' style="margin-top: 10px;">
      <div class='col-3'>
        <div *ngIf="criandoRespostas==0">
          <div class="loader">
            <div class="wrapper">
              <div class="text">AGUARDANDO</div>
              <div class="box"></div>
            </div>
          </div>
        </div>
        <div *ngIf="criandoRespostas==1" class="boxProcessando">
          PROCESSANDO...
        </div>
        <div *ngIf="criandoRespostas==2" class="boxAprovado">
          SUCESSO
        </div>
        <div *ngIf="criandoRespostas==3" class="boxErro">
          ERRO
        </div>    
      </div> 
      <div class='col-9'>  
        <mat-card [class]="criandoRespostas==1 ? 'cardLabelProcessando' : 
                              criandoRespostas==2 ? 'cardLabelProcessado' :
                              criandoRespostas==3 ? 'cardLabelErro' :
                            'cardLabel' ">
            
            <label *ngIf="criandoRespostas==1 || criandoRespostas==0">Criação de Rerguntas </label>
            <label *ngIf="criandoRespostas==2">Na criação de Rerguntas </label>
            <label *ngIf="criandoRespostas==3">Ao criar Rerguntas </label>
            
          </mat-card>          
      </div>
      
    </div>

   
    
    <div class='row' style="margin-top: 10px;">
      <div class='col-3'>
        <div *ngIf="criandoVinculosEntrePerguntasRespostas==0">
          <div class="loader">
            <div class="wrapper">
              <div class="text">AGUARDANDO</div>
              <div class="box"></div>
            </div>
          </div>
        </div>
        <div *ngIf="criandoVinculosEntrePerguntasRespostas==1" class="boxProcessando">
          PROCESSANDO...
        </div>
        <div *ngIf="criandoVinculosEntrePerguntasRespostas==2" class="boxAprovado">
          SUCESSO
        </div>
        <div *ngIf="criandoVinculosEntrePerguntasRespostas==3" class="boxErro">
          ERRO
        </div>      
      </div> 
      <div class='col-9'>  
        <mat-card [class]="criandoVinculosEntrePerguntasRespostas==1 ? 'cardLabelProcessando' : 
                            criandoVinculosEntrePerguntasRespostas==2 ? 'cardLabelProcessado' :
                            criandoVinculosEntrePerguntasRespostas==3 ? 'cardLabelErro' :
                          'cardLabel' ">
            
            <label *ngIf="criandoRespostas==1 || criandoRespostas==0">Criação de vinculos entre Perguntas e Respostas </label>
            <label *ngIf="criandoRespostas==2">Na criação de vinculos entre Perguntas e Respostas </label>
            <label *ngIf="criandoRespostas==3">Ao criar vinculos entre Perguntas e Respostas </label>

          </mat-card>          
      </div>
      
    </div>


    <div class='row' style="margin-top: 10px;">
      <div class='col-3'>
        &nbsp;   
      </div> 
      <div class='col-9'>  
        <div  style="width:100%; height: 110px; border-radius: 5px; font-weight: bold;" [class]="msgSucesso ? 'cardLabelProcessado' : msgErro ? 'cardLabelErro' : 'cardLabelAguardando' ">
          <div style="text-align: center;" *ngIf="!msgSucesso && !msgErro"><br/>Processando...</div>
          <div style="text-align: center;" *ngIf="msgSucesso"><br/>{{data.dsFormulario}} COPIA <br/> Criado com sucesso !</div>
          <div style="text-align: center;" *ngIf="msgErro"><br/>Erro no processo.<br/>Obs: Os passos enteriores ao erro foram criados. </div>
        </div>

      </div>
      
    </div>

    
    
    
    
    
    
    

  </div>

</div>
